import { Component, OnInit, Output, EventEmitter,ViewChild,ChangeDetectorRef  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { menulist }  from '../class/status';
import { ToastComponent } from "../../layout/toast/toast.component";
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
@Component({
    selector: 'app-appinfo',
    templateUrl: './appinfo.component.html',
    styleUrls: ['./appinfo.component.css']
})

export class AppinfoComponent implements OnInit {
    @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;
    constructor(
        public httpClient: HttpClient,
        private cdr: ChangeDetectorRef
    ){}

    ngOnInit(): void {
        this.init_list();
    }
    loading:boolean=true;
    data:any=[];
    edit_data:any=[];
    sort_obj:any = {column:'create_dt',sort:'0'}
    pageobj:page = {page:0,count:10,total_count:0};
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    now:string = '1';
    edit_os = '0';
    points:any = '0';
    menu_list:menulist = [
      // {id:'0',name:'上版事前工作'},
        {id:'1',name:'修改版號'},
        {id:'config',name:'App 開關設定'}//id 故意不用數字 免得被當成 get_app_version 的 action 送出去
    ]

    // 添加這些屬性
    apkSystem: string = 'android';
    apkFile: File = null;
    apkFileName: string = '';
    uploadProgress: number = 0;


    init_list(){
        this.loading = true;
        const body = {
            action:this.now,
            page: this.pageobj.page,
            count:this.pageobj.count,
            sort_obj:this.sort_obj
        };
        this.httpClient.post<any>("/setting/get_app_version.php",body).subscribe(res => {
            this.loading = false;
            console.log('load',res);
            if(res.status){
                this.data = res.data;
                this.points = res.points;
                this.edit_data = JSON.parse(JSON.stringify(res.data));//複製一份
                this.pageobj.total_count = res.total_count;
            }else{
                this.data = [];
            }

        });
    }

    save(){
        if(this.edit_os=='1'||this.edit_os=='2'){
            const os = this.edit_os == '1'?'安卓':'ios';
            let title = '請再次確定'+os+'版號無誤?';
            Swal.fire({
                title: title,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "確定",
                cancelButtonText: "取消",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    const body = {
                        data:this.data,
                        os: this.edit_os,
                    };
                    this.httpClient.post<any>("/setting/set_app_version.php",body).subscribe(res => {
                        this.loading = false;
                        console.log('set',res);
                        if(res.status){
                            Swal.fire("修改完成!", "", "success");
                        }else{
                            Swal.fire("喔喔 出問題了!", "", "error");
                        }
                        //資料還原
                        this.edit_os = '0';
                        this.init_list();
                    });

                }
            });
        }else{
            this.toastComponent.showMessage('參數有誤請再次確認', 'error');
        }
    }

    check(old_val,new_val,item_name){
        if(old_val>new_val){
            Swal.fire(item_name+"小於舊版號請注意", "", "warning");
        }
    }

    choose(value:string){
        this.now = value;
        this.pageobj.total_count = 0;
        this.pageobj = {page:0,count:10,total_count:0};
        this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));
    }

    setAppInfo(type: number): void {
        const actionText = type === 1 ? '啟用' : '關閉';
        Swal.fire({
            title: `確定要${actionText}公告與背包道具嗎?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: '確定',
            cancelButtonText: '取消',
        }).then((result) => {
            if (result.isConfirmed) {
                this.loading = true;
                const body = { type: type };
                this.httpClient.post<any>('/setting/set_appinfo.php', body).subscribe(res => {
                    this.loading = false;
                    if (res.status) {
                        Swal.fire('修改完成!', '', 'success');
                    } else {
                        Swal.fire('喔喔 出問題了!', res.msg || '', 'error');
                    }
                });
            }
        });
    }

    toggleStatus(): void {
        this.points = this.points > 0 ? 0 : 1;
        this.loading = true;
        const body = {
            action:2, //修改送審狀態
            points:this.points,
            page: this.pageobj.page,
            count:this.pageobj.count,
            sort_obj:this.sort_obj
        };
        this.httpClient.post<any>("/setting/get_app_version.php",body).subscribe(res => {
            this.loading = false;
            console.log('set',res);
            if(res.status){
                Swal.fire("修改完成!", "", "success");
            }else{
                Swal.fire("喔喔 出問題了!", "", "error");
            }
            //資料還原
            this.init_list();
        });

    }

    // 處理文件選擇
    uploadApk(event: any) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            this.apkFile = fileList[0];
            this.apkFileName = 'talkmate_android.apk';
        }
    }

        // 上傳到 FTP 服務器 - 分塊上傳版本
    submitApkUpload() {
        if (!this.apkFile) {
            alert('請先選擇 APK 文件');
            return;
        }

        this.loading = true;
        this.uploadProgress = 0;

        const chunkSize = 5 * 1024 * 1024; // 5MB 每塊
        const uploadUrl = environment.serverurl + "/setting/get_app_version.php";

        this.uploadFileInChunks(
            this.apkFile,
            chunkSize,
            uploadUrl,
            Dep.token,
            (progress) => {
                this.uploadProgress = progress;
                this.cdr.detectChanges();
            },
            (data) => {
                this.loading = false;
                alert('APK 文件上傳成功！');
                this.apkFile = null;
                this.apkFileName = '';
                this.init_list(); // 重新加載列表
            },
            (error) => {
                this.loading = false;
                alert('上傳失敗: ' + error);
                console.error('Upload error:', error);
            }
        );
    }

    // 分塊上傳函數
    uploadFileInChunks(file, chunkSize, uploadUrl, token, onProgress, onComplete, onError) {
        const totalChunks = Math.ceil(file.size / chunkSize);
        let currentChunk = 0;
        const fileName = 'talkmate_android.apk';
        const fileId = new Date().getTime(); // 用於標識文件的唯一ID
        const system = this.apkSystem; // 獲取系統類型

        const uploadNextChunk = () => {
            if (currentChunk >= totalChunks) {
                // 所有塊上傳完成，通知服務器合併文件
                const formData = new FormData();
                formData.append('action', 'merge');
                formData.append('fileId', fileId.toString());
                formData.append('fileName', fileName);
                formData.append('totalChunks', totalChunks.toString());
                formData.append('token', token);
                formData.append('system', system);
                formData.append('send_file', '1');

                const xhr = new XMLHttpRequest();
                xhr.open('POST', uploadUrl, true);

                xhr.onload = () => {
                    try {
                        const response = JSON.parse(xhr.response);
                        if (response.status) {
                            onComplete(response);
                        } else {
                            onError(response.message || '合併文件失敗');
                        }
                    } catch (e) {
                        onError('解析合併響應時發生錯誤');
                    }
                };

                xhr.onerror = () => {
                    onError('合併請求發送失敗');
                };

                xhr.send(formData);
                return;
            }

            const start = currentChunk * chunkSize;
            const end = Math.min(file.size, start + chunkSize);
            const chunk = file.slice(start, end);

            const formData = new FormData();
            formData.append('action', 'upload_chunk');
            formData.append('fileId', fileId.toString());
            formData.append('chunkIndex', currentChunk.toString());
            formData.append('totalChunks', totalChunks.toString());
            formData.append('fileName', fileName);
            formData.append('chunk', chunk, 'chunk_' + currentChunk);
            formData.append('token', token);
            formData.append('system', system);
            formData.append('send_file', '1');

            const xhr = new XMLHttpRequest();
            xhr.open('POST', uploadUrl, true);

            xhr.onload = () => {
                try {
                    const response = JSON.parse(xhr.response);
                    if (response.status) {
                        currentChunk++;
                        const progress = Math.round((currentChunk / totalChunks) * 100);
                        onProgress(progress);
                        uploadNextChunk();
                    } else {
                        onError(response.message || '上傳塊失敗');
                    }
                } catch (e) {
                    onError('解析響應時發生錯誤');
                }
            };

            xhr.onerror = () => {
                onError('塊上傳請求發送失敗');
            };

            xhr.send(formData);
        };

        // 開始上傳第一個塊
        uploadNextChunk();
    }
}
